import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import useAuthStore from '@/stores/authStore';
import LandingPage from '@/pages/LandingPage';

/**
 * Component that shows the landing page for unauthenticated users
 * and redirects authenticated users to the dashboard
 */
export function AuthenticatedRoute() {
  const { isAuthenticated, isLoading, organization, user } = useAuthStore();
  const [searchParams] = useSearchParams();

  // Detect Stripe checkout success and persist a short-lived marker
  const checkoutSuccess = searchParams.get('checkout') === 'success' || searchParams.has('session_id');
  useEffect(() => {
    if (checkoutSuccess) {
      try {
        localStorage.setItem('rr_last_checkout_success_at', String(Date.now()));
      } catch {}
      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('checkout');
        url.searchParams.delete('session_id');
        window.history.replaceState({}, '', url.toString());
      } catch {}
    }
  }, [checkoutSuccess]);

  // Show nothing while loading auth state
  if (isLoading) {
    return null;
  }

  // If authenticated, go to dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // If not authenticated, show landing page
  return <LandingPage />;
}